import { RootState } from "@/store/types";

export const selectAuth = (state: RootState) => state.auth;
